import { sortByName } from "../../../../shared/utility";
import { ADD_VISUAL_EFFECT_TO_SCENE, CLEAR_SCENE_VISUAL_EFFECTS_REDIRECT, FETCH_VISUAL_EFFECTS_IN_SCENE } from "./actions";

const defaultState = {
  visualEffect: {},
  visualEffects: [],
  loading: true,
  saving: false
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_VISUAL_EFFECTS_IN_SCENE + "_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case FETCH_VISUAL_EFFECTS_IN_SCENE + "_FULFILLED": {
      return {
        ...state,
        visualEffects: action.payload.data.visualEffects,
        loading: false,
        errors: null
      };
    }

    case FETCH_VISUAL_EFFECTS_IN_SCENE + "_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.response.data.errors
      };
    }

    case ADD_VISUAL_EFFECT_TO_SCENE + "_PENDING": {
      return {
        ...state,
        saving: true,
        errors: null
      };
    }

    case ADD_VISUAL_EFFECT_TO_SCENE + "_FULFILLED": {
      const visualEffect = action.payload.data.visualEffect;
      const visualEffects = [...state.visualEffects, visualEffect];
      sortByName(visualEffects);
      const { fromBreakdown } = action.meta;
      return {
        ...state,
        visualEffects,
        saving: false,
        errors: null,
        redirect: { to: fromBreakdown ? "breakdown" : "list" }
      };
    }

    case ADD_VISUAL_EFFECT_TO_SCENE + "_REJECTED": {
      return {
        ...state,
        saving: false,
        errors: action.payload.response.data.errors
      };
    }

    case CLEAR_SCENE_VISUAL_EFFECTS_REDIRECT: {
      return {
        ...state,
        visualEffect: null,
        redirect: null
      };
    }

    default:
      return state;
  }
};

export default reducer;
